import Contact from "components/Contact";
import React from "react";
import { Link } from "react-router-dom";
import CookieBar from "components/Cookie/CookieBar";

import settings from "configs/settings";
import useWindowSize from "functions/useWindowSize";

import logo_transparent from "assets/images/csango10-logo-transparent-1.svg";

import clg from "functions/log";

//forwardRef : App-ból továbbított ref, ami a footerre mutat.

const Footer = ({ forwardRef, }) => {
  const ws = useWindowSize();


const [cookieSettingsOpen,setCookieSettingsOpen] = React.useState(false);

  return (
    <>
    <footer className="site-footer container-fluid overlay" ref={forwardRef}>
      <div className="upper overlay">
        <div className="scroll-top">
          <i
            className="fas fa-chevron-up"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          ></i>
        </div>
        <div className="row justify-content-around">
          <div className="contact-content d-flex align-items-center">
            <div className="row">
              <div className="col-12 footer-logo-container">
                <img
                  src={logo_transparent}
                  alt="Csángó 10 logo"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                />
              </div>
              <div className="col-12 title mb-3">Elérhetőségeink</div>
              <a
                href={`tel:${settings.contact.phone}`}
                className="col-12 text-with-icon"
              >
                <i className="fas fa-phone"></i>
                <div className="contact-content-inner">
                  <span className="text-name">Telefonszám</span>
                  <span className="text-value">{settings.contact.phone}</span>
                </div>
              </a>
              <a
                href={`mailto:${settings.contact.email}`}
                className="col-12 text-with-icon"
              >
                <i className="fas fa-envelope"></i>
                <div className="contact-content-inner">
                  <span className="text-name">E-mail</span>
                  <span className="text-value">{settings.contact.email}</span>
                </div>
              </a>
              <a className="col-12 text-with-icon">
                <i className="fas fa-paint-roller"></i>
                <div className="contact-content-inner">
                  <span className="text-name">Bemutatóterem</span>
                  <span className="text-value">
                    {settings.contact.show_room}
                  </span>
                </div>
              </a>
              <a className="col-12 text-with-icon">
                <i className="fas fa-tools"></i>
                <div className="contact-content-inner">
                  <span className="text-name">Építkezés</span>
                  <span className="text-value">
                    {settings.contact.construction}
                  </span>
                </div>
              </a>
              <a className="col-12 text-with-icon">
                <i className="fas fa-building"></i>
                <div className="contact-content-inner">
                  <span className="text-name"></span>
                  <span className="text-value">{settings.contact.company}</span>
                </div>
              </a>
              {/* <div className="col-12 socials">
                                <div className="row">
                                    <a href={settings.contact.facebook} className="text-with-icon mb-0"><i className="fab fa-facebook-f"></i></a>
                                    <a href={settings.contact.instagram} className="text-with-icon mb-0"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div> */}
            </div>
          </div>
          <div className="contact-card foot">
            <div className="card-title">Vedd fel velünk a kapcsolatot!</div>

            {/* <div style={{background : "#913374", padding : 10, borderRadius : 4, marginBottom : 14, color : "#ffffff", fontWeight : 600, maxWidth : "fit-content"}}>2024. december 17. és 2025. január 6. között szabadságon vagyunk. Boldog, békés karácsonyt, valamint sikerekben gazdag új évet kívánunk!</div> */}

            <Contact />
          </div>
        </div>
      </div>
      <div className="row lower">
        <div className="col-12 lower-container mb-2">
          <div className="single">
            <a
              href={settings.files.privacyPolicy}
              rel="noopener noreferrer"
              target="_blank"
            >
              Adatkezelési tájékoztató
            </a>
          </div>
        </div>
        <div className="col-12 lower-container mb-2">
          <div className="single">
            <a
              href={settings.files.cookiePolicy}
              rel="noopener noreferrer"
              target="_blank"
            >
              Süti tájékoztató
            </a>
          </div>
        </div>
        <div className="col-12 lower-container">
          <div className="single">
            <span onClick={() => setCookieSettingsOpen(true)}>Sütibeállítások testreszabása</span>
          </div>
        </div>
        <div className="col-12 copyright mt-3">
          <span>Copyright csango10.hu © {new Date().getFullYear()}</span>
          <span>
            Made by{" "}
            <a target="_blank" rel="noreferrer" href="https://petadev.com">
              Petadev
            </a>{" "}
            {ws.width < 576 ? <br /> : "|"} Hosted by{" "}
            <a target="_blank" rel="noreferrer" href="https://petanetwork.hu">
              Petanetwork
            </a>
          </span>
        </div>
      </div>
    </footer>

    <CookieBar cookieSettingsOpen={cookieSettingsOpen} setCookieSettingsOpen={setCookieSettingsOpen}/>

    </>
  );
};

export default Footer;
